import * as systemRoles from '../../../../../constants/system-roles';

export const APPRAISER_SYSTEM_ROLES = [systemRoles.INTERNAL_ATM, systemRoles.ISACA_MDDAP_APPRAISER];
